import { EMAIL_SET_VALUE, setEmailValid, OTP_SET_VALUE, setOtpValid } from '../../../actions/eaTravelRates/auth';
import { validateAlphaNumericString, validateEmail, validateName, validateNumericString } from '@om/validation';
import { validationIsEqual } from '../status';

let prevValidationAction = null;

export const authFormValidation = (store, next, action) => {
    const validationAction = (() => {
        let error = null;

        const validateString = (value, min, subject) => {
            const validators = [validateName, validateAlphaNumericString, validateNumericString];

            let customError = null;

            for (const validate of validators) {
                customError = validate(value, { min, subject });
                if (!customError) break;
            }

            return customError;
        };

        switch (action.type) {
            case EMAIL_SET_VALUE:
                error = validateEmail(action.value, {
                    min: 6,
                    max: 200,
                    subject: 'Email address',
                    required: true,
                });
                return setEmailValid(error);

            case OTP_SET_VALUE:
                error = validateString(action.value);
                return setOtpValid(error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
